export default __webpack_public_path__ + "static/media/svg-3.dc8b0e1e.svg";